import { render, staticRenderFns } from "./PasosA.vue?vue&type=template&id=35e68292&lang=pug&"
import script from "./PasosA.vue?vue&type=script&lang=js&"
export * from "./PasosA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports